import { render, staticRenderFns } from "./CommonTabs.vue?vue&type=template&id=c5fddb1a&scoped=true"
import script from "./CommonTabs.vue?vue&type=script&lang=ts"
export * from "./CommonTabs.vue?vue&type=script&lang=ts"
import style0 from "./CommonTabs.vue?vue&type=style&index=0&id=c5fddb1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fddb1a",
  null
  
)

export default component.exports